export const defaultAppConfig = {
  app_name: "NeonGlyph",
  app_description: "NeonGlyph is a browser-based, single-page SVG logo generator with a retro-futuristic neon studio aesthetic. Users type a short textual prompt, optionally upload or link a style image, and fine-tune color palette, size, and font before instantly rendering and downloading a resolution-independent SVG logo—no account required.",
  app_tagline: "Instant Neon-Futuristic Logos",
  production: process.env.NODE_ENV === "production",
  app_url: process.env.APP_URL || "",
  app_id: process.env.APP_ID || "",
  
  app_logo_url_light:
    "https://app-assets.constructr.ai/34681b27-112b-4926-86a3-d38bf79a39e1/branding/logo-light.png",
  app_logo_url_dark:
    "https://app-assets.constructr.ai/34681b27-112b-4926-86a3-d38bf79a39e1/branding/logo-dark.png",

  app_full_logo_url_light:
    "https://app-assets.constructr.ai/34681b27-112b-4926-86a3-d38bf79a39e1/branding/logo-full-light.png",
  app_full_logo_url_dark:
    "https://app-assets.constructr.ai/34681b27-112b-4926-86a3-d38bf79a39e1/branding/logo-full-dark.png",

  app_badge_show: true,
  app_badge_href: "https://constructr.ai?utm_source=badge&utm_campaign=badge",
  app_badge_src: "https://assets.constructr.ai/images/made-with-badge.png",
  app_badge_alt: "Made with Constructr",
  allow_remix: false
};



